export function formatNumber(n) {
  if (n == null || isNaN(n)) return "0";
  return Math.round(n).toLocaleString("id-ID");
}

export function rupiah(n) {
  return "Rp " + formatNumber(n || 0);
}

export function parseNum(str) {
  if (typeof str === "number") return str;
  const digits = String(str || "").replace(/[^0-9]/g, "");
  return digits ? parseInt(digits, 10) : 0;
}

export function fmtDate(iso) {
  if (!iso) return "-";
  try {
    const d = new Date(iso);
    return d.toLocaleDateString("id-ID", { day: "2-digit", month: "short", year: "numeric" });
  } catch {
    return iso;
  }
}

export function fmtDateTime(iso) {
  if (!iso) return "-";
  try {
    const d = new Date(iso);
    return d.toLocaleString("id-ID", {
      day: "2-digit", month: "short", year: "numeric", hour: "2-digit", minute: "2-digit",
    });
  } catch {
    return iso;
  }
}

export const ROLE_LABELS = {
  master: "Master",
  admin: "Admin",
  gm: "General Manager",
  kasir: "Kasir",
};
